export const STR_ERRORS = {
    SDQRequestFormatRequiresActiveQuery: "SDQRequestFormatRequiresActiveQuery"
};
export const STR = {};
//# sourceMappingURL=index.js.map